import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=343b61de&scoped=true&"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js&"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProducts.vue?vue&type=style&index=0&id=343b61de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343b61de",
  null
  
)

export default component.exports